export default __webpack_public_path__ + "static/media/631.155c5f70.jpg";